import { render, staticRenderFns } from "./RecordedSearchMenu.vue?vue&type=template&id=406355f4&"
import script from "./RecordedSearchMenu.vue?vue&type=script&lang=ts&"
export * from "./RecordedSearchMenu.vue?vue&type=script&lang=ts&"
import style0 from "./RecordedSearchMenu.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports